import {
  type FC
} from 'react';
import {
  Stack,
  Button,
  Typography
} from '@mui/joy';
import {
  ContactUsLink,
  TermsOfUseLink,
} from '@shared/ui';

export type StartPlayingBlockProps = {
  onStartPlaying?(): void;
};

export const StartPlayingBlock: FC<StartPlayingBlockProps> = ({ onStartPlaying }) => (
  <Stack gap={.5} width='100%'>
    <Stack
      alignItems='center'
      justifyContent='center'
      sx={{
        paddingInline: 2,
        paddingBlock: 1.2,
      }}>
      <Typography
        sx={({ palette }) => ({
          fontSize: 14,
          textAlign: 'center',
          color: palette.common[100],
        })}>
        Your redemption request has been submitted <br />
        successfully. It takes 1-2 business days to <br />
        process your order.&nbsp;
        <TermsOfUseLink sx={{ fontSize: 14 }} />
        &nbsp;apply.&nbsp;
        <ContactUsLink sx={{ fontSize: 14 }} >
          For help, please contact our support team.
        </ContactUsLink>
      </Typography>
    </Stack>
    <Button
      fullWidth
      color='success'
      variant='solid'
      onClick={onStartPlaying}>
      Start Playing
    </Button>
  </Stack>
);